"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _view["default"];
  }
});
Object.defineProperty(exports, "name", {
  enumerable: true,
  get: function get() {
    return _slice.name;
  }
});
Object.defineProperty(exports, "reducer", {
  enumerable: true,
  get: function get() {
    return _slice.reducer;
  }
});
Object.defineProperty(exports, "selectInProcess", {
  enumerable: true,
  get: function get() {
    return _slice.selectInProcess;
  }
});
Object.defineProperty(exports, "selectIsOpen", {
  enumerable: true,
  get: function get() {
    return _slice.selectIsOpen;
  }
});
Object.defineProperty(exports, "setProcess", {
  enumerable: true,
  get: function get() {
    return _commands.setProcess;
  }
});
Object.defineProperty(exports, "switchNavigate", {
  enumerable: true,
  get: function get() {
    return _commands.switchNavigate;
  }
});

var _view = _interopRequireDefault(require("./view"));

var _commands = require("./store/commands");

var _slice = require("./store/slice");